import $ from 'jquery';
import _ from 'underscore';
import Cache from 'root/cache';
import Util from 'root/module/util';
import UI from 'root/ui';
import Modals from 'root/modals';
import View from 'view/base';
import View_Emoji from 'view/emoji';

export default View.extend({
    className: 'overlay overlay-sidebar overlay-portal',

    embed: '',

    events: {
        'click .close'        : 'onClose',
        'click .reaction-add' : 'onLike',
        'click .reaction'     : 'onReactionVote'
    },

    dom_handlers: {
        onClose: function(e) {
            this.trigger('close');
        },

        onLike: function(e) {
            e.preventDefault();
            e.stopPropagation();

            if (!(this.views.emoji instanceof View_Emoji)) {
                this.views.emoji = new View_Emoji({
                    onSelect: function(emoji) {
                        this.voteReaction(emoji);
                        this.views.emoji.hide();
                    }.bind(this),
                    launcher: this.$el.find('.region-reactions:first')
                });
                this.views.emoji.render().$el.hide().appendTo(this.$el.find('.region-emoji:first'));
                this.views.emoji.load();
            }

            this.views.emoji.toggle();

            if ($(e.currentTarget).hasClass('reaction-add')) {
                this.views.emoji.$el.css({
                    'right': 0,
                    'bottom': 0,
                    'margin-bottom': 48
                });
            } else {
                this.views.emoji.$el.css({
                    'left': '',
                    'margin-bottom': ''
                });
            }
        },

        onReactionVote: function(e) {
            e.stopPropagation();

            var emoji = $(e.currentTarget).find('.emoji').text();
            this.voteReaction(emoji);
        }
    },

    event_handlers: {},

    initialize: function(options) {
        this.embed = options.embed;

        this.views = {
            emoji: {}
        };
    },

    voteReaction: function(emoji) {
        if (!Cache.real_user_id && !Cache.portal_user && !Cache.guest_user) {
            return;
        }

        Cache.app.request({
            action: 'portal_announcement/reaction',
            data: {
                id: this.model.id,
                emoji: '0x' + emoji.codePointAt(0).toString(16)
            },
            context: this,
            success: function(response) {
                this.model.set('reaction', response.reaction);
                this.renderReactions();
            }
        });
    },

    renderReactions: function() {
        var html = '';
        var reactions = this.model.get('reaction');

        if (reactions) {
            try {
                reactions = JSON.parse(reactions);
            } catch(e) {
            }

            reactions.forEach(function(reaction) {
                html += '<span class="reaction">' +
                            '<span class="emoji">' + String.fromCodePoint(reaction.emoji) + '</span>' +
                            '<span class="count">' + reaction.count + '</span>' +
                        '</span>';
            });
        }

        if (Cache.real_user_id || Cache.portal_user || Cache.guest_user) {
            html += '<button type="button" class="reaction-add"></button>';
        }

        this.$el.find('.region-reactions:first').html(html);
    },

    getShareLink: function() {
        return window.location.href;
    },

    render: function() {
        var content = '';
        var content_html = '';

        var content_raw_data = this.model.get('content');

        content_html = Util.markdownToHtml(content_raw_data);

        var categories = '';

        if (this.model.get('category')) {
            this.model.get('category').split(',').forEach(function(category_name) {
                categories += '<div class="announcement-category-value badge-round badge-primary-invert">' + category_name + '</div>';
            });
        }

        var button = '';

        if (this.model.get('button_text')) {
            if (this.model.get('button_link')) {
                button = '<a href="' + this.model.escape('button_link') + '" target="_blank"><button type="button" class="primary small">' + this.model.escape('button_text') + '</button></a>';
            } else {
                button = '<button type="button" class="primary small">' + this.model.escape('button_text') + '</button>';
            }
        }

        var created_user = Cache.user.get(this.model.get('created_by'));

        content +=
            '<div class="portal-announcement-preview portal-announcement-details">' +
                '<button type="button" class="close btn-close">' +
                    (this.embed === 'widget' ?
                    '<i class="fa-regular fa-chevron-left"></i>' : '<i class="fa-regular fa-xmark"></i>') +
                '</button>' +
                '<div class="portal-announcement-main">' +
                    (this.model.id ?
                    '<div class="portal-announcement-heading">' +
                        '<div class="portal-announcement-title">' + this.model.get('title') + '</div>' +
                    '</div>' +
                    '<div class="portal-announcement-body">' +
                        '<div class="created-by">' +
                        (created_user ? 'Created by ' + created_user.escape('name') + ', ' : '') +
                        Util.moment(this.model.get('publish_time'), 'DD MMM YYYY', false, false) +
                        (this.model.get('is_draft') ? '<span class="badge-warning-invert margin-left-8">Draft</span>' : '') +
                        (!this.model.get('is_draft')  && this.model.isScheduled() ? '<span class="badge-warning-invert margin-left-8">Scheduled</span>' : '') +
                        '</div>' +

                        '<div class="announcement-category">' + (categories ? categories : '') + '</div>' +

                        (this.model.get('feature_image') ? '<div class="announcement-feature-img"><img src="' + this.model.get('feature_image') + '" /></div>' : '') +
                        (this.model.get('feature_video') ? '<div class="announcement-feature-img"><video preload="metadata" src="' + this.model.escape('feature_video') + '" controls muted></video></div>' : '') +
                        '<div class="announcement-content tiptap-content">' + content_html + '</div>' +
                        '<div class="announcement-footer flex-between">' +
                            '<div class="announcement-custom-button margin-top-24">' + button + '</div>' +
                            '<div class="announcement-actions">' +
                                '<div class="announcement-reaction">' +
                                    '<div class="region-reactions"></div>' +
                                    '<div class="region-emoji"></div>' +
                                '</div>' +
                            '</div>' +
                        '</div>' +
                    '</div>' :
                    '<div class="no-post">' +
                        '<div><i class="far fa-eye-slash"></i></div>' +
                        '<h2>Oops</h2>' +
                        '<div class="text-info">The post couldn\'t be found</div>' +
                    '</div>') +
                '</div>' +
            '</div>';

        this.$el.html(content);

        this.renderReactions();

        return this;
    }
});